import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { VerifyOtpResponse } from '../models/verify-otp-respons.interface';
import { RequestOtp } from '../models/request-otp.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthOtpService {
  private readonly httpClient = inject(HttpClient);
  private readonly cookies = inject(CookieService);

  requestOtp(phone: string) {
    return this.httpClient.post<RequestOtp>(
      `${environment.baseUrl}auth/customer/request-otp/`,
      { phone_number: phone }
    );
  }

  verifyOtp(phone: string, otp: string, transactionId: string) {
    return this.httpClient.post<VerifyOtpResponse>(
      `${environment.baseUrl}auth/customer/verify-otp/`,
      { phone_number: phone, otp_code: otp, transaction_req_id: transactionId }
    );
  }

  saveAccessFromVerifyResponse(res: VerifyOtpResponse) {
  this.cookies.delete('access_token', '/');

  const access = res?.tokens?.access;
  console.log('verify response:', res);
  console.log('access token from response:', access);

  if (!access) return;

  this.cookies.set(
    'access_token',
    access,
    undefined,
    '/',
    undefined,
    true,
    'Lax'
  );

}

  getAccessToken(): string | null {
    return this.cookies.get('access_token') || null;
  }

  clearAccessToken() {
    this.cookies.delete('access_token', '/');
  }
}